import type { RitiriOggi } from "./data/mockRitiri";

// Fallback mostrato prima del primo fetch e quando l'API non risponde.
// Stesso shape della risposta /api/orders/pickup-summary ma con tutti
// i contatori a 0. Il componente OrdiniRitiriSide gestisce "Nessun
// ritiro oggi" quando sda.colli + sda.orders + brt.orders_* sono 0.
/** Audit 2026-05-13: ``buildEmptyRitiri`` invece di top-level const.
 *  La data del fallback viene valutata al momento del render, non al
 *  primo import del modulo: se l'app desktop resta aperta a cavallo della
 *  mezzanotte (caso reale per Davide) la data display rifletteva il
 *  giorno precedente finche' non arrivava il primo fetch live. */
export function buildEmptyRitiri(): RitiriOggi {
  const now = new Date();
  return {
    date: now.toISOString().slice(0, 10),
    date_display: new Intl.DateTimeFormat("it-IT", {
      day: "2-digit",
      month: "2-digit",
    }).format(now),
    sda: {
      carrier: "SDA",
      colli: 0,
      volume_m3: 0,
      peso_kg: 0,
      max_l: 0,
      max_p: 0,
      max_a: 0,
      orders: 0,
    },
    brt: {
      carrier: "BRT",
      colli_pacchi: 0,
      colli_bancali: 0,
      volume_m3: 0,
      peso_kg: 0,
      orders_pacchi: 0,
      orders_bancali: 0,
    },
    other: { carrier: "OTHER", colli: 0, volume_m3: 0, peso_kg: 0, orders: 0 },
  };
}
